import React from 'react'
import { connect } from 'react-redux'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImageCarousel from '../image_carousel'
import Text from '../text'
import Button from '../button'
import {
  MARKETPLACE_LISTING_COLOR_OPTIONS,
  MARKETPLACE_LISTING_CONDITIONS,
  MARKETPLACE_LISTING_YEAR_OPTIONS,
} from '../../constants'

class MarketplaceListingPreview extends ImmutablePureComponent {

  render() {
    const { attrs, categories, medias, availableAttrs } = this.props
    
    if (!attrs || !categories || !availableAttrs) return null
    
    const title = attrs.get('title', 'Listing title')
    const locationValue = attrs.get('location', '')
    const price = attrs.get('price', '')
    const descriptionValue = attrs.get('description', '')
    const category = attrs.get('category', '')
		const condition = attrs.get('condition', '')

    const categoryItem = !!category ? categories.find((c) => c.get('id') == category) : null
    const conditionBlock = MARKETPLACE_LISTING_CONDITIONS.find((c) => c.value == condition)
    const conditionTitle = !!conditionBlock ? conditionBlock.title || 'All' : ''
    const mediaAttachmentSrcs = !!medias ? medias.map((media) => media.get('surl')).toJS() : []
		const availableAttrsForCategory = !!category && !!categoryItem ? availableAttrs.get(categoryItem.get('slug')) : null

    return (
      <div className={[_s.d, _s.calcH106PX, _s.bgPrimary, _s.w100PC, _s.maxW80PC, _s.mt15, _s.px15, _s.py15, _s.radiusSmall, _s.overflowHidden, _s.boxShadowModal, _s.mlAuto, _s.mrAuto].join(' ')}>
        <Text weight='bold' className={_s.mb15}>Preview</Text>
        <div className={[_s.d, _s.flexRow, _s.flex1, _s.bgPrimary, _s.radiusSmall, _s.overflowHidden, _s.border1PX, _s.borderColorSecondary].join(' ')}>
          <div className={[_s.d, _s.cursorNotAllowed, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.bottom0, _s.z2].join(' ')} />
          <div className={[_s.d, _s.flex1, _s.overflowHidden, _s.bgSubtle, _s.borderRight1PX, _s.borderColorSecondary].join(' ')}>
            <ImageCarousel
              images={mediaAttachmentSrcs}
              size={mediaAttachmentSrcs.length}
            />
          </div>
          <div className={[_s.d, _s.w380PX, _s.z3, _s.aiEnd].join(' ')} style={{ filter: 'opacity(0.675) grayscale(1)' }}>
            <nav aria-label="Primary" role="navigation" className={[_s.d, _s.w100PC, _s.pb15, _s.overflowYScroll, _s.flex1].join(' ')}>
              {/* ----------------------------------------------------------------------- */}

              <div className={[_s.d, _s.mt5, _s.px15, _s.py5].join(' ')}>
                <Text size="extraExtraLarge" weight="bold">{title}</Text>
                <Text size="medium" className={_s.mt5}>{price === 'Price' ? price : `$${price}`} </Text>
                <Text size="small" color="secondary" className={_s.mt15}>Listed a few seconds ago</Text>
              </div>

              <div className={[_s.d, _s.w100PC, _s.pt15].join(' ')}>
                <div className={[_s.d, _s.flex1, _s.overflowHidden].join(' ')}>
                  <div className={[_s.d, _s.px15, _s.mb15, _s.pb5].join(' ')}>
                    <Text size="large" weight="bold" className={[_s.mt5, _s.mb15].join(' ')}>Description</Text>
                    <div className={_s.dangerousContent}>
                      {descriptionValue}
                    </div>
                  </div>
                </div>
                <div className={[_s.d, _s.w100PC, _s.px15, _s.pt15, _s.mt5, _s.borderTop1PX, _s.borderColorSecondary].join(' ')}>
                  <Text size="large" weight="bold" className={[_s.mt5, _s.mb15].join(' ')}>Details</Text>

                  {
                    !!categoryItem &&
                    <div className={[_s.d, _s.mt5, _s.mb10, _s.flexRow, _s.flexWrap, _s.jcSpaceBetween].join(' ')}>
                      <Text weight="medium">Category</Text>
                      <Text className={_s.maxW100PC}>{categoryItem.get('name')}</Text>
                    </div>
                  }
                  {
                    !!conditionTitle &&
                    <div className={[_s.d, _s.mt5, _s.mb10, _s.flexRow, _s.flexWrap, _s.jcSpaceBetween].join(' ')}>
                      <Text weight="medium">Condition</Text>
                      <Text className={_s.maxW100PC}>{conditionTitle}</Text>
                    </div>
                  }
                  {
                    !!locationValue &&
                    <div className={[_s.d, _s.mt5, _s.mb10, _s.flexRow, _s.flexWrap, _s.jcSpaceBetween].join(' ')}>
                      <Text weight="medium">Location</Text>
                      <Text className={_s.maxW100PC}>{locationValue}</Text>
                    </div>
                  }

                  {
                    !!availableAttrsForCategory && availableAttrsForCategory.map((availableAttr) => {
                      const aaKey = availableAttr.get('key')
                      const aaType = availableAttr.get('type')
                      const aaTitle = availableAttr.get('title')
                      const aaOptions = availableAttr.get('options')
                      let aaValue = attrs.getIn(['attrs', aaKey])
                      const isSelect = ['color', 'year', 'select', 'multiple'].indexOf(aaType) > -1
                      let aaActualOptions = 
                        ['select', 'multiple'].indexOf(aaType) > -1 ? aaOptions.toJS() :
                        aaType === 'color' ? MARKETPLACE_LISTING_COLOR_OPTIONS :
                        aaType === 'year' ? MARKETPLACE_LISTING_YEAR_OPTIONS : []

                      if (isSelect) {
                        const r = aaActualOptions.find((a) => a.value === aaValue)
                        if (!!r) aaValue = r.title
                      }
                      if (aaType === 'boolean') aaValue = !!aaValue ? 'Yes' : 'No'
                      
                      return (
                        <div className={[_s.d, _s.mt5, _s.mb10, _s.flexRow, _s.flexWrap, _s.jcSpaceBetween].join(' ')}>
                          <Text weight="medium">{aaTitle}</Text>
                          <Text className={_s.maxW100PC}>{aaValue}</Text>
                        </div>
                      )
                    })
                  }

                </div>
              </div>

            </nav>

            <div className={[_s.d, _s.px15, _s.pb15, _s.borderColorSecondary, _s.borderTop1PX, _s.w100PC].join(' ')}>
              <div className={[_s.d, _s.mt10, _s.w100PC].join(' ')}>
                <Button isDisabled radiusSmall isBlock color='black' className={[_s.mt10, _s.aiCenter].join(' ')}>
                  <Text color="inherit" size="medium" weight="bold">Message</Text>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    medias: state.getIn(['marketplace_listing_editor', 'media_attachments']),
    attrs: state.getIn(['marketplace_listing_editor', 'attrs']),
    categories: state.getIn(['marketplace_listing_categories', 'items']),
    availableAttrs: state.getIn(['marketplace_listing_search', 'available_attrs']),
  }
}

export default connect(mapStateToProps)(MarketplaceListingPreview)
